/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
export const noop = (...args: unknown[]): void => undefined;
